import { useCallback } from 'react';

import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import { Modal } from 'src/common/primitives/Modal';

import { adminActions } from '../admin.slice';
import { MomentmSettingsFormController } from '../forms/MomentmSettingsForm';

export function MomentmSettingsFormModal() {
  const dispatch = useAppDispatch();
  const editingMomentmSettingsId = useAppSelector(
    (state) => state.admin.editingMomentmSettingsId
  );
  const showMomentmSettingsModal = useAppSelector(
    (state) => state.admin.showMomentmSettingsModal
  );

  const handleClose = useCallback(() => {
    dispatch(adminActions.setShowMomentmSettingsModal(false));
  }, [dispatch]);

  return (
    <Modal
      open={showMomentmSettingsModal}
      onClose={handleClose}
      onInteractOutside={handleClose}
      setOpen={handleClose}
      title={
        editingMomentmSettingsId
          ? 'Edit Momentm Settings'
          : 'Add Momentm Settings'
      }
    >
      <div className="flex w-full flex-col gap-2 md:min-w-[350px]">
        <h3 className="text-[24px] font-medium leading-6 text-gray-900">
          {editingMomentmSettingsId
            ? 'Edit Momentm Settings'
            : 'Add Momentm Settings'}
        </h3>
        <MomentmSettingsFormController settingsId={editingMomentmSettingsId} />
      </div>
    </Modal>
  );
}
